import React from "react";

import { Breadcrumb, SubNav } from "components/nav"; // Z: hide title button to restrict access
import routes from "routes";
import { useAuthDataContext } from "modules/auth";
export interface PageProps {
  isLoading?: boolean;
  children?: React.ReactNode;
  titleButtons?: React.ReactNode;
  titleSupplement?: React.ReactNode;
  status?: string;
}

export const Page = ({
  titleSupplement,
  children,
  titleButtons,
  isLoading,
  status,
}: PageProps) => {
  const { enforcer } = useAuthDataContext();
  return (
    <>
      <header className="shadow-md">
        <div className="max-w-7xl flex flex-wrap -mt-2 justify-between mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold flex items-center leading-tight text-gray-900 mt-2">
            <Breadcrumb routes={routes} />
            {titleSupplement}
          </h1>
          {<SubNav routes={routes} enforcer={enforcer} />}
          {titleButtons && (
            <div className="items-center leading-tight flex mt-2">
              {titleButtons}
            </div>
          )}
        </div>
      </header>
      <main className={status ? "pb-10" : ""}>
        <div className="max-w-7xl mx-auto py-6 px-2 sm:px-6 lg:px-8 text-gray-700">
          {isLoading ? (
            <span className="px-2 font-bold">Please wait. Loading...</span>
          ) : (
            children
          )}
        </div>
        {status && (
          <div
            className="fixed bottom-0 right-0 bg-gray-800 text-white p-4 z-40"
            data-testid="status"
          >
            {status}
          </div>
        )}
      </main>
    </>
  );
};
